import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const BrandsDropdownContent = css`
  display: flex;
  justify-content: center;
  width: 100vw;
  margin-bottom: 1rem;
  padding: 2rem 0 1.5rem 0;
`;

export const BrandContent = css`
  max-width: 1280px;
  width: 100%;
  margin: 0 2rem;
  @media (max-width: ${dimensions.widescreenMax}) {
    width: 100%;
    margin-left: 1rem;
  }
`;
